import React, { Component } from 'react';
import {
  PAYPAL_THEME,
  Card,
  Button,
  Container,
  BodyText,
  HeadingText,
} from '@paypalcorp/pp-react';
import { Dialog } from '@paypalcorp/pp-react-modal';
import DonationModal from '../DonationModal';
import styles from './groupDonation.less';
import * as analytics from '../../lib/analytics';
import get from 'lodash/get';
import MediaQuery from 'react-responsive';
import SheetTrigger from '../SheetTrigger';

export default class GroupDonation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  renderModal = (donationDetails, isGroup) => {
    let virtualCharity = get(this.props, 'campaignInfo.virtualCharity', '');
    return (
      <Dialog
        isOpen={this.state.isOpen}
        onClose={this.closeGroupModal}
        id={`test-${donationDetails.groupVirtualNpid}`}
      >
        <DonationModal
          i18n={this.props.i18n}
          charity={donationDetails}
          enable={this.props.enable}
          campaignInfo={this.props.campaignInfo}
          isMobile={this.props.isMobile}
          fptiInfo={this.props.fptiInfo}
          csrf={this.props.csrf}
          isGroupDonation={isGroup}
          virtualCharity={virtualCharity}
          cdnHost={this.props.cdnHost}
        />
      </Dialog>
    );
  };

  closeGroupModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleDonateClick = (e, npid, charity) => {
    this.setState({
      isOpen: true,
    });

    analytics.trackLinkWithData(
      'gtgCTA',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  render() {
    let gtgSection = get(
      this.props,
      'campaignInfo.templateData.giveToGroupSection',
      ''
    );
    const defaultImg = `https://${this.props.cdnHost}/digitalassets/c/paypal-ui/illustrations/svg/donations.svg`;

    let gtgImage = gtgSection.groupImage ? gtgSection.groupImage : defaultImg;

    let groupDonationDetail = gtgSection.groupDonationDetail;
    const gtgDesktopCardContent = (
      <Card.Content className={styles.cardContent}>
        <div className={styles.gtgflexContainer}>
          <div
            className={styles.gtgImage}
            style={{
              background: `url(${gtgImage}) no-repeat center, center`,
            }}
          />
          <div className={styles.gtgContent}>
            <HeadingText size='sm' className={styles.gtgTitle} medium>
              {gtgSection.groupTitle}
            </HeadingText>
            <BodyText
              className={styles.gtgDesc}
              size='sm'
              style={{ color: PAYPAL_THEME.sysColorBackgroundMediumContrast }}
            >
              {gtgSection.groupDescription}
            </BodyText>
            <MediaQuery minWidth={601}>
              <Button
                type='submit'
                onClick={(e) =>
                  this.handleDonateClick(
                    e,
                    groupDonationDetail.groupVirtualNpid
                  )
                }
                id={`test-${groupDonationDetail.groupVirtualNpid}`}
                className={styles.buttonStyle}
              >
                {gtgSection.groupCTA}
              </Button>
            </MediaQuery>
            <MediaQuery maxWidth={600}>
              <SheetTrigger
                TriggerComponent={
                  <Button
                    id={`test-${groupDonationDetail.groupVirtualNpid}`}
                    className={styles.buttonStyle}
                  >
                    {gtgSection.groupCTA}
                  </Button>
                }
              >
                <DonationModal
                  i18n={this.props.i18n}
                  charity={groupDonationDetail}
                  enable={this.props.enable}
                  campaignInfo={this.props.campaignInfo}
                  isMobile={this.props.isMobile}
                  fptiInfo={this.props.fptiInfo}
                  csrf={this.props.csrf}
                  isGroupDonation={this.props.isGroupDonation}
                  virtualCharity={get(
                    this.props,
                    'campaignInfo.virtualCharity',
                    ''
                  )}
                  cdnHost={this.props.cdnHost}
                />
              </SheetTrigger>
            </MediaQuery>
          </div>
        </div>
      </Card.Content>
    );

    const gtgMobileCardContent = (
      <Card.Content className={styles.cardContent}>
        <div className={styles.gtgflexContainer}>
          <div
            className={styles.gtgImage}
            style={{
              background: `url('https://${this.props.cdnHost}/digitalassets/c/paypal-ui/illustrations/svg/donations.svg') no-repeat center, center`,
            }}
          />
          <div className={styles.gtgContent}>
            <HeadingText size='sm' className={styles.gtgTitle} medium>
              {gtgSection.groupTitle}
            </HeadingText>
          </div>
        </div>
        <div className={styles.gtgMobileDescLayout}>
          <BodyText size='lg'>{gtgSection.groupDescription}</BodyText>
          <MediaQuery minWidth={601}>
            <Button
              type='submit'
              onClick={(e) =>
                this.handleDonateClick(e, groupDonationDetail.groupVirtualNpid)
              }
              id={`test-${groupDonationDetail.groupVirtualNpid}`}
              className={styles.buttonStyle}
            >
              {gtgSection.groupCTA}
            </Button>
          </MediaQuery>
          <MediaQuery maxWidth={600}>
            <SheetTrigger
              TriggerComponent={
                <Button
                  id={`test-${groupDonationDetail.groupVirtualNpid}`}
                  className={styles.buttonStyle}
                >
                  {gtgSection.groupCTA}
                </Button>
              }
            >
              <DonationModal
                i18n={this.props.i18n}
                charity={groupDonationDetail}
                enable={this.props.enable}
                campaignInfo={this.props.campaignInfo}
                isMobile={this.props.isMobile}
                fptiInfo={this.props.fptiInfo}
                csrf={this.props.csrf}
                isGroupDonation={this.props.isGroupDonation}
                virtualCharity={get(
                  this.props,
                  'campaignInfo.virtualCharity',
                  ''
                )}
                cdnHost={this.props.cdnHost}
              />
            </SheetTrigger>
          </MediaQuery>
        </div>
      </Card.Content>
    );

    return (
      <Container className={styles.giveToGroupContainer} id={this.props.id}>
        <HeadingText as='h3' size='md' className={styles.gtgHeader}>
          {gtgSection.groupHeader
            ? gtgSection.groupHeader
            : this.props.i18n('label.gtg-default-header')}
        </HeadingText>
        <HeadingText as='h3' size='sm'>
          {gtgSection.groupSubHeader
            ? gtgSection.groupSubHeader
            : this.props.i18n('label.gtg-default-sunHeader')}
        </HeadingText>
        <Card card className={styles.giveToGroupCard}>
          {!this.props.isMobile && gtgDesktopCardContent}
          {this.props.isMobile && gtgMobileCardContent}
          <div>
            {this.state.isOpen &&
              this.renderModal(groupDonationDetail, this.props.isGroupDonation)}
          </div>
        </Card>
      </Container>
    );
  }
}
